export const OPEN_STARS_INCREASE = "OPEN_STARS_INCREASE";
export const CLOSE_STARS_INCREASE = "CLOSE_STARS_INCREASE";
export const SET_STARS_INCREASE_DATA = "SET_STARS_INCREASE_DATA";
